var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon3NuCoach = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.947 18.719c-.473-.799-.174-1.858.134-2.578.787-.714 1.4-1.696 1.741-2.834.09.125.194.197.309.197.349 0 .63-.676.63-1.51 0-.832-.281-1.507-.63-1.507l-.017.002C19.948 7.402 18.629 5 14.999 5c-3.728 0-4.958 2.402-5.11 5.49-.007 0-.013-.003-.022-.003-.347 0-.63.675-.63 1.507 0 .834.283 1.51.63 1.51.113 0 .219-.073.312-.199.342 1.14.955 2.122 1.743 2.836.31.72.608 1.78.134 2.578 0 0-8.056 2.916-8.056 6.281h22c0-3.365-8.053-6.281-8.053-6.281z",
    fill: "#1E2969",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon3NuCoach);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-3nu-coach.ce1752f9f7e611afd11d479586909c6a.svg";